import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ClientPolicyHistoryModel from "../../models/client-policy-history";

export default class ClientPolicyHistoryRepository extends BaseRepository {
  static modelClass = ClientPolicyHistoryModel;
  modelName = "client-policy-history";

  async query({ caseId }) {
    return await super.query({
      urlPath: `client_policy/${caseId}/history`,
    });
  }
}
